import React from 'react';
import PropTypes from 'prop-types';
import Link from '../components/Link';

export default function Logo({ width, height, color }) {
  return (
    <Link to="/">
      <svg
        width={width}
        height={height}
        fill={color}
        viewBox="0 0 848 193"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M746 161V30h6.838l80.346 72.65V30H848v131h-6.838l-80.346-72.65V161zM672 30h30v131h-30zM570.333 145.76h14.955c4.026 0 7.477-1.708 10.353-4.556 2.875-2.847 4.026-6.265 4.026-10.252V58.617c0-3.987-1.726-7.404-4.602-10.252-2.875-2.848-6.326-3.987-10.353-3.987h-14.954v101.383h.575zM541 160V29h58.667c8.052 0 14.954 2.848 20.706 8.543C626.124 43.24 629 50.073 629 58.048v72.904c0 7.974-2.876 14.809-8.627 20.505-5.752 5.695-12.654 8.543-20.706 8.543H541zM424.183 159.882V28.55H409.28L380.05 43.396v14.847h14.902v102.21h29.232v-.571zm80.244 3.997c0 15.988-13.183 29.121-29.232 29.121H346.232C330.182 193 317 179.867 317 163.879V29.12C317 13.133 330.183 0 346.232 0h129.536C491.818 0 505 13.133 505 29.121V163.88h-.573zM205 161V30h29.484v116.699H279V161zM132 30h30v131h-30zM29.333 145.76h14.955c4.026 0 7.477-1.708 10.353-4.556 2.875-2.847 4.6-6.265 4.6-10.252v-14.809c0-9.682-5.176-14.808-14.953-14.808H29.333v44.426zm0-58.095h14.955c4.026 0 7.477-1.708 10.353-4.556 2.875-2.848 4.6-6.266 4.6-10.252v-14.81c0-3.986-1.725-7.404-4.6-10.251-2.876-2.848-6.327-3.987-10.353-3.987H29.333v43.856zM0 160V29h58.667c8.052 0 14.954 2.848 20.706 8.543C85.124 43.24 88 50.073 88 58.048v7.404c0 8.544-2.3 15.378-7.477 19.935-4.601 5.126-12.079 7.974-21.856 9.113 9.777 0 17.255 2.848 21.856 8.543C85.124 108.74 88 115.573 88 123.548v7.404c0 7.974-2.876 14.809-8.627 20.505C73.62 157.152 66.719 160 58.667 160H0z" />
      </svg>
    </Link>
  );
}

Logo.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string
};

Logo.defaultProps = {
  color: '#F36C21',
  width: '200px',
  height: 'auto'
};
